export { ThankyouRoute } from './ThankyouRoute';
